// @flow

export const getIsReadonly = (state) => state.auth.user?.isReadonly;
export const getPurchaseOrders = (state) => state.purchaseOrder.orders;
export const getRequestedInvoices = (state) => state.invoice.requestedInvoices;
export const getAssociatedProviderInvoices = (state) => state.invoice.associatedInvoices;
export const getAccountInvoices = (state) => state.invoice.accountInvoices;
export const getUserRut = (state) => state.auth.user?.rut;
export const getUserCode = (state) => state.auth.user?.userCode;